export const MAX_TRIP_PARTY_SIZE = 6;

export const TRIP_PARTY_AVATARS_TO_SHOW = 4;
